export {
    default as Main,
    IMainProps,
} from './main';
